import React, { FC, useState } from 'react';
import { PositionLocationDropdown } from '@src/components/PositionLocationDropdown';
import { LocationType } from '@src/graphql/generated';
import { LocationListProps } from './props';
import './styles.scss';

export const LocationList: FC<LocationListProps> = ({
  shouldClearOnSelect,
  onLocationSelected,
  defaultValues,
  isInvalid,
}) => {
  const [locations, setLocations] = useState<Pick<LocationType, 'id' | 'placeId' | 'longName' | 'shortName'>[]>(
    defaultValues || [],
  );

  const onLocationSelect = (location: Pick<LocationType, 'id' | 'placeId' | 'longName' | 'shortName'>) => {
    const doesIncludeLocation = locations.some(prevLocation => prevLocation.id === location.id);

    const newLocations = doesIncludeLocation ? locations : [...locations, location];

    setLocations(newLocations);

    onLocationSelected(newLocations);
  };

  const removeLocation = (location: Pick<LocationType, 'id' | 'placeId' | 'longName' | 'shortName'>) => {
    const filteredLocations = locations.filter(prevLocation => prevLocation.id !== location.id);

    setLocations(filteredLocations);

    onLocationSelected(filteredLocations);
  };

  return (
    <div className="location-list">
      {!!locations.length && (
        <div className="location-list-items">
          {locations.map(location => (
            <div className="location-list-item" key={location.id}>
              {location.longName}

              <span className="ui-icon-dismiss-slim" onClick={() => removeLocation(location)} />
            </div>
          ))}
        </div>
      )}

      <PositionLocationDropdown
        shouldClearOnSelect={shouldClearOnSelect}
        onSelect={onLocationSelect}
        placeholder="Start typing the city to add an office"
        isInvalid={isInvalid}
      />
    </div>
  );
};
